module.exports = __webpack_public_path__ + "img/logo.3bc7f9e.svg";